import { AndroidIcon } from "../icons/android-icon";
import { DarwinIcon } from "../icons/darwin-icon";
import { IOSIcon } from "../icons/ios-icon";
import { LinuxIcon } from "../icons/linux-icon";
import { ServerIcon } from "../icons/server-icon";
import { WindowsIcon } from "../icons/windows-icon";

export const PlatformIcon: React.FC<{
  platform?: string;
  className?: string;
}> = ({ platform, className }) => {
  const lowerCasePlatform = platform?.toLowerCase();

  const check = (...values: string[]) =>
    values.some((v) => lowerCasePlatform?.includes(v));

  if (check("darwin", "macos")) {
    return <DarwinIcon className={className} />;
  }
  if (check("ubuntu", "linux")) {
    return <LinuxIcon className={className} />;
  }
  if (check("windows")) {
    return <WindowsIcon className={className} />;
  }
  if (check("ios")) {
    return <IOSIcon className={className} />;
  }
  if (check("android")) {
    return <AndroidIcon className={className} />;
  }
  return <ServerIcon className={className} />;
};
